import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import {serializeQueryParam} from "@/utils";

// eslint-disable-next-line import/prefer-default-export
export const getAllClubs = createAsyncThunk('clubs/getAllClubs',
  async ( param : GetAllClubsProps) => {
    const paramText = serializeQueryParam(param)
    const response: AxiosResponse<ClubsPagination> = await instance.get(`/v1/clubs${paramText}`)

    const { status, ...rest } = param
    const paramText2 = serializeQueryParam({...rest})
    const summaryResponse: AxiosResponse<ClubsSummary> = await instance.get(`/v1/clubs/summary${paramText2}`)

    const clubs = {
      items: response.data.items,
      meta: response.data.paging,
      summary: summaryResponse.data
    } as ClubsState

    return clubs
})


export const deleteClub = createAsyncThunk('clubs/deleteClubs',
  async (id: string,  {dispatch}) => {
    await instance.delete(`/v1/clubs/${id}`)
    dispatch(getAllClubs({status: "", search: ""    }))
})

export const getClubById = createAsyncThunk('clubs/getClubsById',
  async ( {clubId, success } : GetClubProps) => {
    const response: AxiosResponse<Club> = await instance.get(`/v1/clubs/${clubId}`)
    success(response.data)
})

export const updateClub = createAsyncThunk('clubs/updateClub',
  async ( request : ClubRequest,  {dispatch}) => {
    await instance.put(`/v1/clubs/${request.id}`, request)
    dispatch(getAllClubs({status: "", search: ""}))
})

